module.exports = __webpack_public_path__ + "img/img_uploader_photo.16542cc5.png";